import { EditOutlined } from '@ant-design/icons';
import { Button, Space, type TableColumnType, Tag } from 'antd';
import type { TabelaComissaoExcecao } from '@/features/tabela-comissao/types/TabelaComissao';
import type { TabelaComissaoProdutoPartial } from '@/features/tabela-comissao/types/TabelaComissaoProdutoPartial';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { numberToString } from '@/std/format';
import type { TDataTable } from './ProdutoTabComissao';

export interface RowComissaoProduto {
    key: number;
    tac_idpk: number;
    tac_descricao: string;
    tac_percentual: number;
    tac_empresa_idpk: number;
    tac_tipo: number;
    tac_ultima_alteracao: string;
    tabela_comissao_excecao?:
        | PartialUndefinedOrNull<TabelaComissaoExcecao>
        | PartialUndefinedOrNull<TabelaComissaoExcecao>[];
    hasPrecoDif?: string;
    produto?: Partial<TabelaComissaoProdutoPartial>;
}

type TColumns = {
    handleEditar: (row: RowComissaoProduto, index: number) => void;
};

export const columns = ({ handleEditar }: TColumns): TableColumnType<RowComissaoProduto>[] => [
    {
        align: 'left',
        dataIndex: 'tac_descricao',
        ellipsis: true,
        key: 'tac_descricao',
        render: (tapDescricao, record) => (
            <span>
                {tapDescricao || ''}

                {record?.hasPrecoDif && (
                    <Tag color='blue' variant='solid'>
                        {record.hasPrecoDif}
                    </Tag>
                )}
            </span>
        ),
        title: 'Descrição',
    },
    {
        align: 'right',
        dataIndex: 'tac_percentual',
        ellipsis: true,
        key: 'tac_percentual',
        render: (value) => numberToString(value, 'percent'),
        title: 'Percentual',
    },
    {
        align: 'center',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, row, index) => (
            <Space>
                <Button
                    htmlType='button'
                    icon={<EditOutlined />}
                    onClick={() => handleEditar(row, index)}
                    shape='circle'
                    type='primary'
                />
            </Space>
        ),
        title: 'Ações',
        width: '7%',
    },
];

export function formatData(tabelaComissoes: TDataTable[]): RowComissaoProduto[] {
    // @ts-expect-error FIXME
    return tabelaComissoes.map((data) => ({
        hasPrecoDif: data?.hasPrecoDif,
        key: data.tac_idpk,
        // @ts-expect-error FIXME
        produto: data?.produto,
        tabela_comissao_excecao: data?.tabela_comissao_excecao,
        tac_descricao: data.tac_descricao || 'Sem Descrição',
        tac_empresa_idpk: data?.tac_empresa_idpk,
        tac_idpk: data.tac_idpk,
        tac_percentual: data?.tac_percentual || 0,
        tac_tipo: data?.tac_tipo,
        tac_ultima_alteracao: data?.tac_ultima_alteracao || '',
    }));
}
